import {
    Component,
    HostBinding,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { Clinic } from '../../../../shared/state/clinic/clinic.store';
import { UserService } from '../../../../shared/state/user/user.service';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { FlowwerInitializaterComponent } from '../../../../shared/components/flowwwer-initializater-component/flowwwer-initializater-component';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { LibraryService } from '../../../../core/services/library/library.service';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { CompanyPicturesModel } from '../../../../shared/models/company-pictures.model';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { Capacitor } from '@capacitor/core';
import { RouterService } from '../../../../core/services/router/router.service';
import { filter, map, take } from 'rxjs/operators';
import { HeaderPictureQuery } from 'src/app/shared/state/header-picture/header-picture.query';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { fade_in, fade_out } from 'src/app/core/animations/fade';
import { HeaderDesktopComponent } from 'src/app/shared/components/header-desktop/header-desktop.component';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-personalized',
    animations: [fade_out, fade_in],
    templateUrl: './personalized.component.html',
    styleUrls: ['./personalized.component.scss'],
})
export class PersonalizedComponent
    extends FlowwerInitializaterComponent
    implements OnInit, OnDestroy {
    clinics$: Observable<Clinic[]>;
    clinicsLoading$ = this.clinicQuery.selectLoading();
    isBrowser$: Observable<boolean>;
    companyPictures$: Observable<CompanyPicturesModel>;
    headerBackground$;
    headerCollapsed = true;

    @HostBinding('class.backgroundSplash') backgroundSplash = false;
    @HostBinding('class.backgroundFixed') backgroundFixed = false;

    /** Flowwwer template */
    logoHeader: string = null;
    clinicsFav$: Observable<Clinic[]>;
    mapActive = false;

    /** Flowwwer template */
    @ViewChild(HeaderComponent)
    headerComponent: HeaderComponent;
    @ViewChild(HeaderDesktopComponent)
    headerDesktopComponent: HeaderDesktopComponent;
    
    public mapsSrc: SafeUrl = '';

    constructor(
        private clinicQuery: ClinicQuery,
        private router: Router,
        private companyQuery: CompanyQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerPicturesQuery: HeaderPictureQuery,
        librayService: LibraryService,
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        routerService: RouterService,
        private storage: StorageService,
        private sanitizer: DomSanitizer
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            librayService,
            routerService
        );

        // @ts-ignore
        window.initMapPersonalized = () => {
            this.initScriptMap();
        };
    }

    async ngOnInit(): Promise<void> {
        this.backgroundSplash = !this.settingsQuery.browser;
        if (Capacitor.isNativePlatform()) {
            this.backgroundFixed = true;
        }
        this.isBrowser$ = this.settingsQuery.select('browser');
        this.headerBackground$ = this.headerBackgroundQuery.select('home');

        this.isLoadingContent = true;
        try {
            await this.initializeCompanyUserPersonalized();
        } catch (error) {
            this.isLoadingContent = false;
        }
        this.filterClinics('');
        this.checkOneClinic();

        /**
         * Para el login por URL:
         * Si es reseller = -1, borramos el tokenIdAux porque no lo vamos a usar para hacer login
         */
        this.userService.updateTokenIdAux('');

        this.isLoadingContent = false;

        /** Flowwwer template */
        this.headerPicturesQuery
            .select('homeCompany')
            .subscribe((homeCompany) => {
                this.logoHeader = homeCompany;
            });

        this.clinicsFav$ = this.clinicQuery.select('clinicsFav');
    }

    ionViewDidEnter() {
        /** Borramos la clínica guardada */
        this.storage.remove('companyActive');

        this.filterClinics('');

        /** Flowwwer template */
        //TODO, VER esto porque es lento
        this.headerComponent?.resetSearch();
        this.headerDesktopComponent?.clearSearchInput();
    }

    /** Si solamente tiene una clínica nos vamos a ella */
    async checkOneClinic() {
        if (this.clinicQuery.getValue().clinicsFound.length === 1) {
            this.selectClinic(
                this.clinicQuery.getValue().clinicsFound[0],
                true
            );
        }
    }

    /** Función que filtra las clínicas de la Store mediante una key (No llama a la API, solo filtra) */
    filterClinics(searchText) {
        searchText = this.normalizeText(searchText);
        this.clinics$ = this.clinicQuery.select('clinicsFound').pipe(
            map((clinicsFound: Clinic[]) => {
                return clinicsFound.filter(({name, city, address1, address2, address3}: Clinic) => {
                    name = this.normalizeText(name);
                    city = this.normalizeText(city);
                    address1 = this.normalizeText(address1);
                    address2 = this.normalizeText(address2);
                    address3 = this.normalizeText(address3);
                    return name.includes(searchText) || city.includes(searchText) || address1.includes(searchText) || address2.includes(searchText) || address3.includes(searchText);
                });
            })
        );
    }

    /** Esta función se usa para seleccionar una clínica (bien por click o bien programaticamente
     * Una vez la clínica está inicializada en la Store va a la pantalla de clínica
     */
    selectClinic(clinic: Clinic, setRoot: boolean = false) {
        let parentSystemKey = {};
        if (clinic.systemKey !== this.settingsQuery.currentSystemKey) {
            parentSystemKey = {
                queryParams: {
                    parentSystemKey: this.settingsQuery.currentSystemKey,
                },
            };
        }
        if (setRoot) {
            this.navCtrl.navigateRoot(
                [clinic.systemKey + '/' + clinic.id + '/details'],
                parentSystemKey
            );
        } else {
            this.router.navigate(
                [clinic.systemKey + '/' + clinic.id + '/details'],
                parentSystemKey
            );
        }
    }

    /** Función que se llama cuando se pulsa en una clínica en el listado */
    onClinicClicked(clinic: Clinic) {
        this.selectClinic(clinic);
    }

    /** Al destruir el componente nos desuscribimos al observable de los parámetros de esta página */
    ngOnDestroy() {
        this.unsuscribeParamsQueryParams();
    }

    toggleHeader() {
        this.headerCollapsed = !this.headerCollapsed;
    }

    headerHideSearch() {
        this.filterClinics('');
    }

    //TODO: Mejorar mapa. Visualizar mapa en versión mobile
    initScriptMap(): void {
        this.mapsSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${this.settingsQuery.latitude},${this.settingsQuery.longitude}&zoom=18`);
    }

    normalizeText(text: string): string {
        return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
}
